<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-layout wrap="">
        <v-flex xs12 sm6 md4>
          <v-autocomplete
            v-model="select_employer"
            :items="employers"
            item-text="name"
            item-value="id"
            label=" أختر الموظف "
            persistent-hint
            return-object
            single-line
            @change="get_data"
          >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
        </v-flex>
      </v-layout>

      <v-data-table
        :headers="headers"
        :items="e_employers"
        class="elevation-1"
        :loading="loading"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.name }}</td>
          <td>
            {{ props.item.salary }}
          </td>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import {
  clients,
  search_client_by_code,
  madionia_client,
  fatworas_client_no_sadad,
  employers,
  khazna_fatworas,
  add_withdrew
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: " اسم الموظف",
        value: "address",
        sortable: false,
        align: "right"
      },
      { text: " المرتب", value: "address", sortable: false, align: "right" }
    ],
    select_client: { id: "" },
    select_employer: { id: "" },
    search: "",
    comment: "",
    loading: true,

    khazina_fatworas: [],
    clients: [],
    fatworas: [],
    employers: [],
    e_employers: [],
    all_employers: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theKhazna: {},
    money: "",
    searchClientCode: "",
    madionia_sabqa: "",
    madionia_sabqa_of_madionia: ""
  }),

  computed: {
    mycode() {
      if (this.khazina_fatworas.length > 0) {
        return (this.code =
          parseInt(
            this.khazina_fatworas[this.khazina_fatworas.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      clients().then(response => {
        this.clients = response.data;
        this.loading = false;
      });

      employers().then(response => {
        this.employers = response.data;
        this.all_employers = response.data;
        this.e_employers = response.data;
        this.employers.push({ id: "222", name: "الكل", salary: "all" });
        this.employers.push({ id: "333", name: "لا شئ", salary: "no" });
      });

      khazna_fatworas().then(response => {
        this.khazina_fatworas = response.data;
      });
    },

    search_client_by_code() {
      search_client_by_code(this.searchClientCode).then(response => {
        this.select_client = response.data;
        this.get_all_info();
      });
    },
    get_all_info() {
      this.searchClientCode = this.select_client.code;
      this.fatworas = [];
      this.madionia_sabqa = "";
      this.loading = true;
      fatworas_client_no_sadad(this.select_client.id).then(response => {
        this.fatworas = response.data;
        this.loading = false;
      });
      madionia_client(this.select_client.id).then(response => {
        this.madionia_sabqa =
          (response.data.madionia != 0
            ? parseFloat(response.data.madionia)
            : 0) +
          (response.data.client.rasid_efttahi != ""
            ? parseFloat(response.data.client.rasid_efttahi)
            : 0);
        this.madionia_sabqa_of_madionia =
          response.data.madionia != 0 ? parseFloat(response.data.madionia) : 0;
      });
    },

    get_data() {
      if (this.select_employer.salary == "all") {
        this.e_employers = [];
        this.e_employers = this.all_employers;
      } else if (this.select_employer.salary == "no") {
        this.e_employers = [];
      } else {
        this.e_employers = [];
        this.e_employers.push(this.select_employer);
      }
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    add_withdrew() {
      let myUser = JSON.parse(localStorage.getItem("user"));

      this.khazna_fatwora_table.code = this.mycode;
      this.khazna_fatwora_table.emp_name = myUser.name;
      this.khazna_fatwora_table.rasid_before = this.select_employer.rasid;
      this.khazna_fatwora_table.money = this.money;
      this.khazna_fatwora_table.rasid_after = parseFloat(this.money);
      this.khazna_fatwora_table.type = "out";
      this.khazna_fatwora_table.notes = this.comment;
      this.khazna_fatwora_table.khazina_id = this.select_employer.id;

      let khazina_fatwora_ = JSON.stringify(this.khazna_fatwora_table);

      this.khazina_update.id = this.select_employer.id;
      this.khazina_update.rasid = this.money;

      let khazina_ = JSON.stringify(this.khazina_update);

      this.do_deposit(khazina_fatwora_, khazina_);
    },
    do_deposit(khazina_fatwora_, khazina_) {
      this.loading = true;
      var frmData = new FormData();
      frmData.append("khazina", khazina_);
      frmData.append("khazina_fatwora", khazina_fatwora_);
      add_withdrew(frmData).then(response => {
        console.log("reback", response.data);
        this.loading = false;
      });
    },
    push_client_sadad(sadad) {
      this.all_client_sadads.push(sadad);
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.v-picker.v-card.v-picker--date.theme--light {
  direction: ltr;
}
</style>
